/**
 * <XtsCustomAssets> — Renders CustomAssetConfig[] with `binding.type =
 * 'static'`.
 *
 * Movement-bound bindings (`'mover'` and `'all-movers'`) are rendered
 * elsewhere — as children of `<XtsMover>` inside ProcessingUnitRoot —
 * so they automatically inherit the imperatively-driven mover transform
 * each frame, exactly like AT8200 tools. Keeping this component focused
 * on world-fixed assets means the static path stays cheap and the
 * mover-bound path doesn't pay the per-frame `moverWorldAt` cost twice.
 */

import React from 'react';
import { CustomAssetMesh } from './CustomAssetMesh.js';
import type { CustomAssetConfig } from '../../types.js';

interface XtsCustomAssetsProps {
  assets: CustomAssetConfig[];
}

export const XtsCustomAssets: React.FC<XtsCustomAssetsProps> = ({
  assets,
}) => {
  return (
    <group name="xts-custom-assets-static">
      {assets
        .filter((a) => a.visible !== false && a.binding.type === 'static')
        .map((asset) => {
          // Type-narrow once for the static branch.
          const binding = asset.binding as Extract<
            CustomAssetConfig['binding'],
            { type: 'static' }
          >;
          return (
            <CustomAssetMesh
              key={asset.id}
              glbUrl={asset.glbUrl}
              positionMm={binding.positionMm}
              rotationDegEuler={binding.rotationDegEuler}
              scale={binding.scale ?? 1}
              opacity={asset.opacity}
            />
          );
        })}
    </group>
  );
};
